import React, { FC, Fragment } from 'react'
import { Transition, Arrow, useTooltip } from 'react-laag'
import cx from 'classnames'
import styles from './Tooltip.module.scss'

type TooltipDirection = 'BOTTOM_CENTER' | 'TOP_CENTER' | 'LEFT_CENTER' | 'RIGHT_CENTER'

type TooltipProps = {
  label: string
  direction?: TooltipDirection
  className?: string
  color?: string
}

export const Tooltip: FC<TooltipProps> = ({
  children,
  className,
  color,
  label,
  direction = 'BOTTOM_CENTER',
}) => {
  const [element, triggerProps] = useTooltip(
    ({ isOpen, layerProps, arrowStyle, layerSide }) => (
      <Transition isOpen={isOpen}>
        {(isOpen, onTransitionEnd) => (
          <div
            ref={layerProps.ref}
            onTransitionEnd={onTransitionEnd}
            className={cx(styles.tooltip, isOpen && styles.open)}
            style={{ ...layerProps.style, ...{ color, borderColor: color } }}
          >
            {label}
            <Arrow
              style={arrowStyle}
              layerSide={layerSide}
              backgroundColor={styles.whiteColor}
              borderWidth={1}
              borderColor={color ?? styles.borderColor}
            />
          </div>
        )}
      </Transition>
    ),
    {
      delayEnter: 200,
      delayLeave: 100,
      placement: {
        anchor: direction,
        autoAdjust: true,
        triggerOffset: 10,
      },
      fixed: true,
    },
  )

  return (
    <Fragment>
      {element}
      <span className={cx(styles.trigger, className)} {...triggerProps}>
        {children}
      </span>
    </Fragment>
  )
}

Tooltip.displayName = 'Tooltip'
